import React from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import { Avatar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-duotone-svg-icons';
import CryptoJS from 'crypto-js';
import envConfig from './envConfig';
import {
  batteryBrands,
  contactTypes,
  fileTypes,
  installers,
  storageFileProcessesStatus,
} from './utils'

export const isNumeric = (str) => {
  if (typeof str !== 'string') return false // we only process strings!  
  return !Number.isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !Number.isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export const encryptString = (text) => {
  console.log(text.length);
  let encryptedData = '';
  for (let i = 0; i < text.length; i++) {
    const intValue = text[i].charCodeAt(0) + 5;
    encryptedData += String.fromCharCode(intValue);
  }
  return encryptedData;
  // const iv = CryptoJS.lib.WordArray.random(16);
  // const keyWordArray = CryptoJS.enc.Utf8.parse(envConfig.EncryptionKey);
  // const encrypted = CryptoJS.AES.encrypt(text, keyWordArray, {
  //   iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // });
  // const encryptedData = iv
  //   .concat(encrypted.ciphertext)
  //   .toString(CryptoJS.enc.Base64);
  // return encryptedData;
};

export const animationTransition = {
  duration: 0.5,
  ease: [0.43, 0.13, 0.23, 0.96],
};

export const fadeInMotion = {
  opacity: 1,
  transition: animationTransition,
};

export const fadeOutMotion = {
  opacity: 0,
  transition: animationTransition,
};

export const toLocalTime = (date) => {
  if (date) {
    return dayjs(date).subtract(4, 'hour');
  }
  return dayjs().subtract(4, 'hour')
};

export const toFormattedLocalTime = (date) => toLocalTime(date).format('MMM DD, YYYY hh:mm A');

export const toFormattedTime = (date) => date.format('MMM DD, YYYY hh:mm A');

export const toFormattedLocalDate = (date) => toLocalTime(date).format('MMM DD, YYYY');

export const toFormattedLocalHour = (date) => toLocalTime(date).format('hh:mm A');

export function formatNumber(number) {
  if (number) {
    return number.toLocaleString();
  }
  return '';
}

export const percentage = (n, decimalPoints) => {
  let number = n;
  if (number === null || number === undefined) {
    return '0';
  }
  if (number) {
    const wasNegative = number < 0;
    number = parseFloat(number.toString().replace(',', ''));
    if (wasNegative) {
      number = (-1 * number).toFixed(decimalPoints);
    } else {
      number = number.toFixed(decimalPoints);
    }
    const parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const result = parts.join('.');
    if (wasNegative) {
      return `(${result}%)`;
    }
    return `${result}%`;
  }
  return '0';
}

export const thousand = (n, decimalPoints, displayZero) => {
  let number = n;
  if (number === null || number === undefined) {
    if (displayZero) {
      return '0';
    }
    return '-';
  }
  if (number) {
    const wasNegative = number < 0;

    let tempDecimal = 0;
    if (decimalPoints) {
      tempDecimal = decimalPoints;
    }
    number = parseFloat(number.toString().replace(',', ''));
    if (!decimalPoints && number % 1 === 0) {
      tempDecimal = 0;
    } else if (!decimalPoints) {
      tempDecimal = 2;
    }
    if (wasNegative) {
      number = (-1 * number).toFixed(tempDecimal);
    } else {
      number = number.toFixed(tempDecimal);
    }
    const parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const result = parts.join('.');
    if (wasNegative) {
      return `(${result})`;
    }
    return `${result}`;
  }
  return '0';
};

export const thousandAutoDecimal = (n) => {
  const number = n;
  if (number === null || number === undefined) {
    return '';
  }
  if (number) {
    const parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const result = parts.join('.');
    return `${result}`;
  }
  return '0';
};

export const checkNumber = (n, decimals) => {
  if (n === null || n === undefined) {
    return '';
  }
  const number = n.toString();
  const periodCount = (number.match(/\./g) || []).length;
  if (decimals > 0) {
    if (periodCount > 1 && number.endsWith('.')) {
      return number.substring(0, number.length - 1);
    }
    const parts = number.toString().split('.');
    if (parts.length > 1 && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
    }
    const result = parts.join('.');
    return parseFloat(result.replace(',', ''));
  }
  const parts = number.toString().split('.');
  return parseFloat(parts[0].replace(',', ''));
}

export const toCurrency = (number) => {
  try {
    if (!number) {
      return '-';
    }
    const wasNegative = number < 0;
    let fixed = 0;
    if (wasNegative) {
      fixed = (-1 * number).toFixed(2);
    } else {
      fixed = number.toFixed(2);
    }
    if (wasNegative) {
      return `($${thousand(fixed, 2)})`;
    }
    return `$${thousand(fixed, 2)}`;
  } catch (error) {
    return '-';
  }
};

export const uuidv4 = () =>
  '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )

export const uploadHistoryStatusToString = (status) => {
  if (status === 1) {
    return 'processing'
  }
  if (status === 2) {
    return 'processed'
  }
  if (status === 3) {
    return 'failed'
  }
  return 'pending'
};

export const mapLogType = (type) => {
  if (type === 0) {
    return 'note';
  }
  if (type === 1) {
    return 'appointment';
  }
  if (type === 2) {
    return 'call';
  }
  if (type === 3) {
    return 'email';
  }
  return 'other';
};

export const mapDealType = (type) => {
  if (type === 0) {
    return 'sunrun';
  }
  if (type === 1) {
    return 'battery';
  }
  return 'other'
};

export const mapLearningVideoExpertLevel = (level) => {
  if (level === 0) {
    return 'beginner';
  }
  if (level === 1) {
    return 'intermediate';
  }
  if (level === 2) {
    return 'advanced';
  }
  if (level === 3) {
    return 'expert';
  }
  return 'other'
};

export const mapLeadStatus = (status) => {
  if (status === 0) {
    return 'waiting'
  }
  if (status === 1) {
    return 'assigned'
  }
  if (status === 2) {
    return 'contact_initiated'
  }
  if (status === 3) {
    return 'appointment_scheduled'
  }
  if (status === 4) {
    return 'proposal_sent'
  }
  if (status === 5) {
    return 'signed'
  }
  if (status === 6) {
    return 'site_survey_scheduled'
  }
  if (status === 7) {
    return 'site_survey_completed'
  }
  if (status === 8) {
    return 'installation_scheduled'
  }
  if (status === 9) {
    return 'installation_completed'
  }
  if (status === 10) {
    return 'completed'
  }
  return 'lost'
}

export const mapLeadStage = (status) => {
  if (status === 0) {
    return 'not_worked'
  }
  if (status === 1) {
    return 'pending'
  }
  if (status === 2) {
    return 'closed'
  }
  if (status === 3) {
    return 'open'
  }
  if (status === 4) {
    return 'lost'
  }
  return 'unknown'
}

export const mapContactType = (contactType) => {
  const filtered = _.filter(contactTypes, (c) => c.id === contactType);
  if (filtered.length === 0) {
    return contactTypes[0].name
  }
  return filtered[0].name;
}

export const mapInstaller = (installer) => {
  const filtered = _.filter(installers, (c) => c.id === installer);
  if (filtered.length === 0) {
    return installer[0].name
  }
  return filtered[0].name;
}

export const mapLeadProgress = (lead) => {
  const d = dayjs();
  const i = dayjs(lead.installationDate);
  const s = dayjs(lead.siteSurveyDate);
  if (lead.activationDate !== null) {
    return 'activated'
  }
  if (lead.installationDate !== null) {
    if (i.isAfter(d)) {
      return 'installation_scheduled';
    }
    return 'installation_completed';
  }
  if (lead.siteSurveyDate !== null) {
    if (i.isAfter(d)) {
      return 'site_survey_scheduled';
    }
    return 'site_survey_completed';
  }
  if (lead.signedDate !== null) {
    return 'signed'
  }
  if (lead.proposalDate !== null) {
    return 'proposal_sent'
  }
  if (lead.appointmentDateTime !== null) {
    return 'appointment_scheduled'
  }
  return 'waiting'
}

export const mapLeadProgressColor = (lead) => {
  if (lead.lostDate !== null) {
    return 'gray'
  }
  if (lead.activationDate !== null) {
    return 'blue'
  }
  if (lead.installationDate !== null) {
    return 'green'
  }
  if (lead.siteSurveyDate !== null) {
    return 'orange'
  }
  if (lead.signedDate !== null) {
    return 'orange'
  }
  if (lead.proposalDate !== null) {
    return 'orange'
  }
  if (lead.appointmentDateTime !== null) {
    return 'orange'
  }
  return 'red'
}

export const storageFileProcessesStatusToString = (status) => {
  const filtered = _.filter(storageFileProcessesStatus, (s) => s.id === status)
  return filtered[0].name;
}

export const mapAppointmentStatus = (status) => {
  if (status === 0) {
    return 'not_held';
  }
  if (status === 1) {
    return 'held';
  }
  if (status === 2) {
    return 'failed_credit';
  }
  if (status === 3) {
    return 'revisit';
  }
  return 'cancelled';
}

export const getWaitTimeText = (lead, t) => {
  let date = null;
  const suffix = 'ago';
  const prefix = t('in');
  if (lead.status === 0) { // PendingAssignment
    date = lead.createdAt;
  } else if (lead.status === 1) { // Assigned
    date = lead.assignedOn;
  } else if (lead.status === 2) { // ContactInitiated
    date = lead.contactedOn;
  } else if (lead.status === 3) { // AppointmentScheduled
    date = lead.appointmentDateTime;
  } else if (lead.status === 4) { // ProposalSent
    date = lead.proposalDate;
  } else if (lead.status === 5) { // Signed
    date = lead.signedDate;
  } else if (lead.status === 6) { // SiteSurveyScheduled
    date = lead.siteSurveyDateScheduled;
  } else if (lead.status === 7) { // SiteSurveyCompleted
    date = lead.siteSurveyDate;
  } else if (lead.status === 8) { // InstallationScheduled
    date = lead.installationDateScheduled;
  } else if (lead.status === 9) { // Installed
    date = lead.installationDate;
  } else if (lead.status === 10) { // Completed
    date = lead.activationDate;
  } else if (lead.status === 11) { // Lost
    date = lead.lostDate;
  }
  if (date === null) {
    return '';
  }
  const d = dayjs(date).subtract(4, 'hour');
  let hours = dayjs().diff(d, 'hour');
  if (hours === 0) {
    return t('just_now');
  }
  // Recently within the last hour
  const isNegative = hours < 0;
  if (isNegative) {
    // console.log('isNegative', isNegative);
    hours *= -1;
    // return `${prefix} t ${hours} ${t('hour(s)')}`;
  }
  // If the date is in the current or past day
  if (hours >= 0 && hours < 24) {
    if (isNegative && hours === 1) return `an ${t('hour')} ${suffix}`;
    if (isNegative) return `${prefix} ${hours} ${t('hour(s)')}`;
    if (!isNegative) return `${hours} ${t('hours')} ${suffix}`;
  }
  // If the date is in the past
  if (hours >= 24 && hours < 720) {
    const days = dayjs().diff(d, 'day');
    if (!isNegative && days === 1) return `a ${t('day')} ${suffix}`;
    if (!isNegative) return `${days} ${t('day(s)')} ${suffix}`;
    if (isNegative) return `${prefix} ${-days} ${t('day(s)')}`;
  }

  if (hours >= 720) {
    const months = dayjs().diff(d, 'month');
    if (!isNegative && months === 1) return `a ${t('month')} ${suffix}`;
    if (!isNegative) return `${months} ${t('month(s)')} ${suffix}`;
    if (isNegative) return `${prefix} ${-months} ${t('month(s)')}`;
  }

  return 'test';
}

export const getWaitTime = (date, t) => {
  const d = dayjs(date);
    return dayjs().diff(d, 'day');
}

export const getDatePresets = (t) => [
  {
    label: t('today'),
    value: () => [dayjs(), dayjs()]
  },
  {
    label: t('yesterday'),
    value: () => [dayjs().add(-1, 'day'), dayjs().add(-1, 'day')]
  },
  {
    label: t('current_week'),
    value: () => [dayjs().startOf('week'), dayjs().endOf('week')]
  },
  {
    label: t('last_week'),
    value: () => [dayjs().add(-1, 'week').startOf('week'), dayjs().add(-1, 'week').endOf('week')]
  },
  {
    label: t('current_month'),
    value: () => [dayjs().startOf('month'), dayjs().endOf('month')]
  },
  {
    label: t('past_month'),
    value: () => [dayjs().add(-1, 'months').startOf('month'), dayjs().add(-1, 'months').endOf('month')]
  },
  {
    label: t('last_2_month'),
    value: () => [dayjs().add(-1, 'month').startOf('month'), dayjs().endOf('month')]
  },
  {
    label: t('last_3_month'),
    value: () => [dayjs().add(-2, 'month').startOf('month'), dayjs().endOf('month')]
  },
  {
    label: t('year_to_date'),
    value: () => [dayjs().startOf('year'), dayjs()]
  },
  {
    label: t('current_year'),
    value: () => [dayjs().startOf('year'), dayjs().endOf('year')]
  }
];

function randomUtility(length) {
  return Math.floor(Math.random() * length);
}

export const randomColor = () => {
  const hex = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F'];
  let hexColor = '#';
  for (let i = 0; i < 6; i++) {
    hexColor += hex[randomUtility(hex.length)];
  }
  return hexColor;
};

export const getCloserSummaryTableColumns = (t) => [
  {
    title: '',
    align: 'left',
    className: 'text-sm w-full md:hidden',
    render: (row) => (
      <div className="grid grid-cols-2 gap-2 w-full">
        <div className="col-span-2 text-center">
          <>
            {row?.user && (
              <div>
                <p>
                  {/* <Avatar src={row?.user?.avatar} className="bg-primaryColor h12 w-8 mr-2" /> */}
                  {row?.user?.completeName}
                </p>
                <p className="font-light">{t('max_active_deals')}: {thousand(row.user?.closerMaxActiveDeals)}</p>
              </div>
            )}
            {!row?.user && (
              <span>-</span>
            )}
          </>
        </div>
        <div className="col-span-2 text-center">
          <p><span className="font-bold">{`${t('conversion')} ${t('installed')} vs ${t('signed')}`}</span> {percentage(row.historicalConvertionSignedInstalled * 100, 2)}</p>
        </div>
        <div className="col-span-2 text-center">
          <p><span className="font-bold">{t('all_opportunities')}:</span> {thousand(row.totalOpportunities)}</p>
        </div>
        <div className="col-span-1">
          <p><span className="font-bold">{t('referrals_by_customer')}:</span> {thousand(row.totalReferralsByCustomer)}</p>
        </div>
        <div className="col-span-1 text-right">
        <p><span className="font-bold">{t('self-gen')}:</span> {thousand(row.totalSelfGen)}</p>
        </div>
        <div className="col-span-1">
        <p><span className="font-bold">{t('closer_setter')}:</span> {thousand(row.totalCloserSetter)}</p>
        </div>
        <div className="col-span-1 text-right">
          <p><span className="font-bold">{t('leads')}:</span> {thousand(row.totalLeads)}</p>
        </div>
        <div className="col-span-1">
          <p><span className="font-bold">{t('signed_deals')}:</span> {thousand(row.totalSigned)}</p>
        </div>
        <div className="col-span-1 text-right">
          <p><span className="font-bold">{t('active_deals')}:</span> {thousand(row.totalDeals)}</p>
        </div>
        <div className="col-span-1">
          <p><span className="font-bold">{t('installs')}:</span> {thousand(row.totalInstalls)}</p>
        </div>
        <div className="col-span-1 text-right">
          <p><span className="font-bold">{t('lost')}:</span> {thousand(row.totalLost)}</p>
        </div>
      </div>
    ),
  },
  {
    title: t('closer'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.user?.completeName.toLocaleLowerCase().localeCompare(b.user?.completeName.toLocaleLowerCase()),
    render: (row) => (
      <>
        {row?.user && (
          <div>
            <p>
              {/* <Avatar src={row?.user?.avatar} className="bg-primaryColor h12 w-8 mr-2" /> */}
              {row?.user?.completeName}
            </p>
            <p className="font-light">{t('max_active_deals')}: {thousand(row.user?.closerMaxActiveDeals)}</p>
          </div>
        )}
        {!row?.user && (
          <span>-</span>
        )}
      </>
    ),
  },
  {
    title: `${t('conversion_ratio')} (${t('installed')} vs ${t('signed')})`,
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.historicalConvertionSignedInstalled - b.historicalConvertionSignedInstalled,
    render: (row) => (
      <span>{percentage(row.historicalConvertionSignedInstalled * 100, 2)}</span>
    ),
  },
  {
    title: t('all_opportunities'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalOpportunities - b.totalOpportunities,
    render: (row) => (
      <span>{thousand(row.totalOpportunities)}</span>
    ),
  },
  {
    title: t('referrals_by_customer'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalReferralsByCustomer - b.totalReferralsByCustomer,
    render: (row) => (
      <span>{thousand(row.totalReferralsByCustomer)}</span>
    ),
  },

  {
    title: t('self-gen'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalSelfGen - b.totalSelfGen,
    render: (row) => (
      <span>{thousand(row.totalSelfGen)}</span>
    ),
  },
  {
    title: t('closer_setter'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalCloserSetter - b.totalCloserSetter,
    render: (row) => (
      <span>{thousand(row.totalCloserSetter)}</span>
    ),
  },
  {
    title: t('leads'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalLeads - b.totalLeads,
    render: (row) => (
      <span>{thousand(row.totalLeads)}</span>
    ),
  },
  {
    title: t('signed'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalSigned - b.totalSigned,
    render: (row) => (
      <span>{thousand(row.totalSigned)}</span>
    ),
  },
  {
    title: t('active'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalDeals - b.totalDeals,
    render: (row) => (
      <span>{thousand(row.totalDeals)}</span>
    ),
  },
  {
    title: t('installs'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalInstalls - b.totalInstalls,
    render: (row) => (
      <span>{thousand(row.totalInstalls)}</span>
    ),
  },
  {
    title: t('lost'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalLost - b.totalLost,
    render: (row) => (
      <span>{thousand(row.totalLost)}</span>
    ),
  },
];

export const getSetterSummaryTableColumns = (t) => [
  {
    title: '',
    align: 'left',
    className: 'text-sm w-full md:hidden',
    render: (row) => (
      <div className="grid grid-cols-2 gap-2 w-full text-center">
        <div className="col-span-2">
          <>
            {row?.user && (
              <span>
                <Avatar src={row?.user?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                {row?.user?.completeName}
              </span>
            )}
            {!row?.user && (
              <span>-</span>
            )}
          </>
        </div>
        <div className="col-span-2">
          <p className="font-bold">{`${t('conversion')} ${t('appointments')} ${t('held')} vs ${t('not_held')}`}:</p>
          <p>{percentage(row.historicalConversionAppointmentsHeld * 100, 2)}</p>
        </div>
        <div className="col-span-2">
          <p><span className="font-bold">{t('leads')}:</span> {thousand(row.totalLeads)}</p>
        </div>
      </div>
    ),
  },
  {
    title: t('user'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.user?.completeName.toLocaleLowerCase().localeCompare(b.user?.completeName.toLocaleLowerCase()),
    render: (row) => (
      <>
        {row?.user && (
          <span>
            <Avatar src={row?.user?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
            {row?.user?.completeName}
          </span>
        )}
        {!row?.user && (
          <span>-</span>
        )}
      </>
    ),
  },
  {
    title: `${t('appointments')} ${t('conversion')} (${t('held')} vs ${t('not_held')})`,
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.historicalConversionAppointmentsHeld - b.historicalConversionAppointmentsHeld,
    render: (row) => (
      <span>{percentage(row.historicalConversionAppointmentsHeld * 100, 2)}</span>
    ),
  },
  {
    title: t('leads'),
    align: 'left',
    className: 'text-sm hidden md:table-cell',
    sorter: (a, b) => a.totalLeads - b.totalLeads,
    render: (row) => (
      <span>{thousand(row.totalLeads)}</span>
    ),
  },
];

export const hasBillFileType = (files, t) => {
  const billEng = t('bill', { lng: 'en' });
  const billSpa = t('bill', { lng: 'es' });
  return _.filter(files, (f) => f.type === billEng || f.type === billSpa || t(f.type) === billEng || t(f.type) === billSpa).length > 0;
}

export const getBillFile = (files, t) => {
  const billEng = t('bill', { lng: 'en' });
  const billSpa = t('bill', { lng: 'es' });
  const bills = _.filter(files, (f) => f.type === billEng || f.type === billSpa);
  if (bills.length > 0) {
    return bills[0];
  }
  return null;
}

export const hasSignedContractFileType = (files, t) => {
  const engFileType = t('signed_contract', { lng: 'en' });
  const spaFileType = t('signed_contract', { lng: 'es' });
  return _.filter(files, (f) => f.type === engFileType || f.type === spaFileType || t(f.type) === engFileType || t(f.type) === spaFileType).length > 0;
}

export const getMobileDatePickerFooter = (t) => (
  <div className="hidden md:hidden">
    <p>{t('swipe_calendar_full_view')} <FontAwesomeIcon icon={faArrowRight} /></p>
  </div>
)

export const getBatteryBrandColors = (brands) => {
  const colors = [];
  for (let i = 0; i < brands.length; i++) {
    const filtered = _.filter(batteryBrands, (bb) => bb.name === brands[i].label);
    if (filtered.length === 1) {
      colors.push(filtered[0].color);
    } else {
      colors.push(randomColor());
    }
  }
  return colors;
}

export const getLocalizedFileType = (type, t) => {
  let localizedType = t(type);
  for (let i = 0; i < fileTypes.length; i++) {
    const eng = t(fileTypes[i], { lng: 'en' });
    const spa = t(fileTypes[i], { lng: 'es' });
    if (eng === type || spa === type) {
      localizedType = t(fileTypes[i]);
    }
  }
  return localizedType;
}

export const getAge = (date, t) => {
  const now = dayjs();
  return `${now.diff(dayjs(date), 'year')} ${t('years_old')}`;
}

const likesAbbrNumberHelper = (likes, mult, abbr) => {
  const tempLikes = likes / mult;
  const remainder = likes % mult;
  if (remainder > 0) {
    return `${thousand(tempLikes, 0, true)}${abbr}`;
  }
  return `${thousand(tempLikes, 1, true)}${abbr}`;
}

export const getLikesAbbrNumber = (likes) => {
  if (likes >= 1000000000) { // Billion
    return likesAbbrNumberHelper(likes, 1000000000, 'B');
  }
  if (likes >= 1000000) { // Million
    return likesAbbrNumberHelper(likes, 1000000, 'M');
  }
  if (likes >= 100000) { // Houndred Thousand
    return likesAbbrNumberHelper(likes, 100000, 'K');
  }
  if (likes >= 1000) { // Thousand
    return likesAbbrNumberHelper(likes, 1000, 'K');
  }
  return likes;
}
